/**
 *  \file:   Weather.vue
 *  \brief   Vue component to handle all weather related information
 *
 *  $Id: Weather.vue,v 1.16 2018/05/01 08:09:50 leif Exp $
 *  $Log: Weather.vue,v $
 */
<template>
  <div
    title="Weather forecast at the Controller's location based on the zip code stored in the CIMS database for the current Controller.  If that data is not present, the forecast is generated from the client's web-browser location."
    class="Weather"
  >
    <br><br>
    <p class="size-one-point-five gap20" />
    <br>
    <div class="weather_container">
      <table>
        <tr>
          <th
            class="weather_title"
            colspan="5"
          >
            {{ info }}
            Forecast for: {{ city }}, {{ state }} {{ zip }} {{ country }}
          </th>
        </tr>
        <tr class="weather_header">
          <td />
          <td
            v-for="(item, index) in forecast"
            :key="index"
          >
            {{ item.date.weekday_short }}&nbsp;&nbsp;{{ item.date.month }}/{{ item.date.day }}
          </td>
        </tr>
        <tr class="weather_row">
          <td />
          <td
            v-for="(item, index) in forecast"
            :key="index"
          >
            <img
              :src="item.icon_url"
              alt="weather icon"
            ><br>
            {{ item.conditions }}
          </td>
        </tr>
        <tr class="weather_row">
          <td>
            <img
              src="@graphics/temperature.png"
              alt="temperature icon"
            >
          </td>
          <td
            v-for="(item, index) in forecast"
            :key="index"
          >
            Low: {{ item.low.fahrenheit }} F<br>
            High: {{ item.high.fahrenheit }} F
          </td>
        </tr>
        <tr class="weather_row">
          <td>
            <img
              src="@graphics//windsock.png"
              alt="wind icon"
            >
          </td>
          <td
            v-for="(item, index) in forecast"
            :key="index"
          >
            {{ item.avewind.mph }} mph
          </td>
        </tr>
        <tr class="weather_row">
          <td>
            <img
              src="@graphics//plant.png"
              alt="wind icon"
            >
          </td>
          <td
            v-for="(item, index) in forecast"
            :key="index"
          >
            {{ item.qpf_allday.in }} in
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'
import $ from 'jquery'

// var apiFile = require('@/assets/apiFile');
// import Wunderground from 'node-weatherunderground';
// var client = new Wunderground();

export default
{
  name: 'Weather',
  components: {
  },
  mixins: [SocketHandler],
  props:
  {
    SocketMessage:
    {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  /**
   *  \brief   Weather.vue component data
   *  \return forecast - 3 days weather forecast data
   *  \return city - city name
   *  \return country - country name
   */
  data() {
    return{
      showAboutModal: false,
      componentName: 'Weather',
      // Weather params
      info: 'Retreiving weather data',
      forecast: '',
      forecastday: [],
      country: '',
      city: '',
      state: '',
      zip: '',
      lat: 0,
      lon: 0
    }
  },
  watch: {
    SocketMessage(Message) {

      //       var x = document.getElementById("demo");

      // function getLocation() {
      //   if (navigator.geolocation) {
      //     navigator.geolocation.getCurrentPosition(showPosition, showError);
      //   } else { 
      //     x.innerHTML = "Geolocation is not supported by this browser.";
      //   }
      // }



      // function showError(error) {
      //   switch(error.code) {
      //     case error.PERMISSION_DENIED:
      //       x.innerHTML = "User denied the request for Geolocation."
      //       break;
      //     case error.POSITION_UNAVAILABLE:
      //       x.innerHTML = "Location information is unavailable."
      //       break;
      //     case error.TIMEOUT:
      //       x.innerHTML = "The request to get user location timed out."
      //       break;
      //     case error.UNKNOWN_ERROR:
      //       x.innerHTML = "An unknown error occurred."
      //       break;
      //   }
      // }

      var msg = Message.data
      if(msg.component && msg.component === 'Weather') {
        var request
        if(msg.data.zip === '') {
          // request = 'http://api.wunderground.com/api/b5376d47f120f30f/geolookup/forecast/q/autoip.json'
          request = 'https//:api.openweathermap.org/data/2.5/forecast/hourly?lat=' +this.lat + '&lon=' + this.lon + '&units=metric&appid=f6d730121ba0e0be73c2c277a99c0ef1'
        } else {
          if(Number(msg.data.zip) > 0) {
            // request = 'http://api.wunderground.com/api/b5376d47f120f30f/geolookup/forecast/q/' + msg.data.zip + '.json'
            request = 'https://api.openweathermap.org/data/2.5/forecast/hourly?zip=' + msg.data.zip + ',us&units=imperial&appid=f6d730121ba0e0be73c2c277a99c0ef1'
          }
        }

        $.getJSON(request).then((response) => {
          this.city = response.location.city
          this.state = response.location.state
          this.zip = response.location.zip
          this.country = response.location.country_name
          this.forecast = response.forecast.simpleforecast.forecastday
        }, (response) => {
          // failure!
          console.warn('Open Weather Map request error: ', request, response)
        })
      }
    }
  },
  mounted() {
    this.SocketMessageSend({component: 'Weather', command: 'Mounted'})
    this.getLocation()
  },
  destroyed() {
    this.SocketMessageSend({component: 'Weather', command: 'Destroyed'})
  },
  /**
   *  \brief   Get 3 days weather forecast from weatherunderground.com
   *  \param   callback - use this function for extracting weather forecast data
   *  \return  void
   */
  methods: {
     getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.usePosition, this.showError)
      } else { 
        this.info = "Geolocation is not supported by this browser."
      }
    },
     usePosition(position) {
      this.lat =  position.coords.latitude 
      this.lon =  position.coords.longitude
    },
     showError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          this.info = "User denied the request for Geolocation."
          break
        case error.POSITION_UNAVAILABLE:
          this.info = "Location information is unavailable."
          break
        case error.TIMEOUT:
          this.info = "The request to get user location timed out."
          break
        case error.UNKNOWN_ERROR:
          this.info = "An unknown error occurred."
          break
      }
    }

  }
}
</script>

<style>
.Weather, .weather_container
{
  width: 600px;
  margin: 0 auto;
}

th.weather_title {
  padding: 20px;
}

tr.weather_header
{
  vertical-align: middle;
  text-align: center;
}

tr.weather_header > td {
  padding: 10px;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
}

tr.weather_row > td {
  vertical-align: middle;
  text-align: center;
  padding: 5px;
  width: 23%;
  border-left: 2px solid #000;
  border-right: 2px solid #000;
}

tr.weather_row > td:first-child {
  width: 10%;
}

tr.weather_header, tr.weather_row:nth-child(even)
{
  background-color: #B6C3C8;
  border-left: 2px solid #ffffff;
}
</style>
